import StorageUtil from './storage-util';
import Utils from './utils';

const KEY_MIX = 'b96f03bfb9';
const KEY_PREFIX = 'smmx';

let KEY_CACHE: {[key: string]: string} = {};

const encodeValue = (value: string) => {
    const payload = new TextEncoder().encode(value);
    const buffer = new Uint8Array(4 + payload.length);
    buffer.set(payload, 4);
    for (let i = 0; i < 4; i++) {
        buffer[i] = Math.floor(Math.random() * 256);
    }
    for (let i = 4; i < buffer.length; i++) {
        buffer[i] ^= buffer[i % 4];
    }
    return Utils.toHex(Array.from(buffer));
};

const decodeValue = (hex: string) => {
    const buffer = Utils.fromHex(hex);
    if (buffer.length <= 4) {
        return '';
    }
    for (let i = 4; i < buffer.length; i++) {
        buffer[i] ^= buffer[i % 4];
    }
    const payload = buffer.subarray(4);
    try {
        return new TextDecoder().decode(payload);
    } catch (e) {
        return '';
    }
};

const getKey = (key: string) => {
    if (KEY_CACHE[key]) {
        return KEY_CACHE[key];
    }
    const hexValue = StorageUtil.getLocalString(`${KEY_PREFIX}${KEY_MIX}`);
    let keys = {};
    if (hexValue) {
        const keyValue = decodeValue(hexValue);
        if (keyValue) {
            try {
                keys = JSON.parse(keyValue);
            } catch (e) {}
        }
    }
    KEY_CACHE = keys;
    if (KEY_CACHE[key]) {
        return KEY_CACHE[key];
    }
    const index = Number(KEY_CACHE.index || 0) + 1;
    KEY_CACHE.index = `${index}`;

    const buffer = new Uint8Array(5);
    buffer[4] = index & 0xff;
    for (let i = 0; i < 4; i++) {
        buffer[i] = Math.floor(Math.random() * 256);
    }
    buffer[4] ^= buffer[0];
    const mixKey = Utils.toHex(Array.from(buffer));
    KEY_CACHE[key] = `${KEY_PREFIX}${mixKey}`;
    const toSave = encodeValue(JSON.stringify(KEY_CACHE));
    StorageUtil.setLocalString(`${KEY_PREFIX}${KEY_MIX}`, toSave);
    return KEY_CACHE[key];
};

const set = (key: string, value: string) => {
    const mixKey = getKey(key);
    if (!value) {
        StorageUtil.removeLocalItem(mixKey);
        return;
    }

    const mixValue = encodeValue(value);
    StorageUtil.setLocalString(mixKey, mixValue);
};

const get = (key: string) => {
    const mixKey = getKey(key);
    const mixValue = StorageUtil.getLocalString(mixKey);
    if (!mixValue) {
        return '';
    }
    return decodeValue(mixValue);
};

export default {
    set,
    get,
};
